<h1 mat-dialog-title>
  <span *ngIf="data.contact.contact_ID" i18n>Edit Contact</span>
  <span *ngIf="data.contact.contact_ID == null" i18n>Add Contact</span>
</h1>
<div>
  <p i18n>Contacts are used for customer communication</p>
  <form #contactForm="ngForm" (ngSubmit)="saveContact(contactForm)" appValidateTextNotificationData>
    <div class="form-group form-inline row-cols-md-3 row-cols-1">
      <div class="control-wrapper">
        <span class="warning">* </span>
        <label for="contactType" i18n>Contact Type</label>
        <select name="contactType_ID" id="contactType_ID"
                required=""
                [(ngModel)]="data.contact.contactType_ID" #contactType_ID="ngModel"
                class="form-control select-bidit">
          <option [ngValue]="undefined">-</option>
          <option *ngFor="let contactType of data.contactTypes" [ngValue]="contactType.contactType_ID">{{contactType.contactType_Desc}}</option>
        </select>
        <div [hidden]="!contactForm.submitted || contactType_ID.valid"
             class="alert alert-danger" i18n>Enter a contact type</div>
      </div>
      <div class="control-wrapper">
        <span class="warning">* </span>
        <label for="fName" i18n>First Name</label>
        <input name="contact_FirstName" id="contact_FirstName"
               [(ngModel)]="data.contact.contact_FirstName" #contact_FirstName="ngModel"
               class="form-control" type="Text" maxlength="50" required="" autofocus="" />
      </div>
      <div class="control-wrapper">
        <span class="warning">* </span>
        <label for="lName" i18n>Last Name</label>
        <input name="contact_LastName" id="contact_LastName"
               [(ngModel)]="data.contact.contact_LastName" #contact_LastName="ngModel"
               class="form-control" type="Text" maxlength="50" required="" />
      </div>
    </div>
    <div class="row">
      <div [hidden]="!contactForm.submitted || (contact_FirstName.valid && contact_LastName.valid)"
           class="alert alert-danger" i18n>Contact First and Last Name Required</div>
    </div>
    <div colspan="form-group form-inline row-cols-2">
      <div class="form-inline">
        <span class="warning" i18n>* Either Phone #, Cell #, or Email address is required</span>
      </div>
    </div>
    <div class="form-group form-inline row-cols-md-3 row-cols-1">
      <div class="control-wrapper">
        <label for="phone" i18n>Phone #</label>
        <input name="contact_Phone" id="contact_Phone" type="text"
               [(ngModel)]="data.contact.contact_Phone" #contact_Phone="ngModel"
               class="form-control" placeholder="(999) 999-9999" appPhoneMask />
      </div>
      <div class="control-wrapper">
        <label for="mobile" i18n>Mobile #</label>
        <input name="contact_Mobile" id="contact_Mobile"
               [(ngModel)]="data.contact.contact_Mobile" #contact_Mobile="ngModel"
               class="form-control" type="Text" placeholder="(999) 999-9999" appPhoneMask />
      </div>
      <div class="control-wrapper">
        <label for="email" i18n>Email Address</label>
        <input name="contact_Email" id="contact_Email" type="email"
               [(ngModel)]="data.contact.contact_Email" #contact_Email="ngModel"
               class="form-control" />
      </div>
    </div>
    <div class="row">
      <div [hidden]="!contactForm.submitted ||
          ((contact_Phone.value != null && contact_Phone.value != '') ||
          (contact_Mobile.value != null && contact_Mobile.value != '') ||
          (contact_Email.value != null && contact_Email.value != ''))"
           class="alert alert-danger" i18n>Contact Phone or Email Required</div>
    </div>
    <div class="row">
      <div *ngIf="contactForm.submitted && (contactForm.errors?.notificationDataInvalid)"
           class="alert alert-danger" i18n>Cell # and Email must be entered if Notification Delivery is Both</div>
    </div>
    <div class="row">
      <div *ngIf="contactForm.submitted && (contactForm.errors?.mobilePhoneInvalid)"
           class="alert alert-danger" i18n>Cell # must be entered if Notification Delivery is Text</div>
    </div>
    <div class="row">
      <div *ngIf="contactForm.submitted && (contactForm.errors?.emailPhoneInvalid)"
           class="alert alert-danger" i18n>Email Address must be entered if Notification Delivery is Email</div>
    </div>
    <div class="form-group form-inline row-cols-md-2 row-cols-1">
      <div class="control-wrapper">
        <label for="contact_receivesNotifications" class="" i18n>Receive Notifications:</label>
        <mat-radio-group area-label="Allows Notifications" id="contact_receivesNotifications" name="contact_receivesNotifications"
                         [(ngModel)]="data.contact.contact_ReceivesNotifications">
          <mat-radio-button [value]="false" class="pr-2" i18n>No</mat-radio-button>
          <mat-radio-button [value]="true" i18n>Yes</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="control-wrapper">
        <label for="notificationDelivery" i18n>Notification Delivery</label>
        <select name="notificationDelivery" id="notificationDelivery"
                [(ngModel)]="data.contact.contact_NotificationDeliveryTypeDesc" #contact_NotificationDeliveryType="ngModel"
                class="form-control select-bidit">
          <option [ngValue]="undefined">-</option>
          <option *ngFor="let notificationType of data.notificationTypes  | keyvalue" [ngValue]="notificationType.key">{{notificationType.value}}</option>
        </select>
        <div class="row">
          <div *ngIf="contactForm.submitted && (contactForm.errors?.deliveryOptionInvalid)"
               class="alert alert-danger" i18n>Must select Delivery Type if contact is to receive notifications</div>
        </div>
      </div>
    </div>
    <div class="form-group form-inline row-cols-md-3 row-cols-1">
      <div class="control-wrapper">
        <div *ngIf="data.contact.contact_OptedOut">
          <label for="optOutDate" i18n>Notification Opt Out Date: </label>
          <span id="optOutDate" name="optOutDate" class="ml-1" i18n>{{data.contact.contact_OptOutDate | date: 'MM/dd/yyyy'}}</span>
        </div>
        <div *ngIf="data.contact.contact_OptedIn">
        <label for="optOutDate" i18n>Notification Opt In Date: </label>
        <span id="optOutDate" name="optOutDate" class="ml-1" i18n>{{data.contact.contact_OptInDate | date: 'MM/dd/yyyy'}}</span>
      </div>
      </div>
    </div>
    <div class="mat-dialog-actions float-end">
      <div *ngIf="!isRequesting">
        <button type="submit" value="submit" name="submit" id="submit" class="btn btn-bidit-submit mr-1" i18n>Submit</button>
        <button mat-button (click)="onNoClick()" class="btn btn-bidit-cancel" i18n>Cancel</button>
        <button *ngIf="checkVerify()" mat-button (click)="sendSMSOptIn()" class=" ml-4 btn btn-bidit-action" i18n>Send Opt-In</button>
      </div>
    </div>
    <app-spinner [isRunning]="isRequesting"></app-spinner>
  </form>
</div>
